import type { IFilterCampaignValue } from './campaign';

export interface IVisitorJourneySubFilter {
  matchType?: EJourneyMatchType;
  campaignData?: IFilterCampaignValue;
}

export interface IFilterVisitorJourneyValue {
  id: string;
  path: string;
  level: number;
  isHeatmap: boolean;
  subFilter?: IVisitorJourneySubFilter;
}

export interface IFilterVisitorJourney {
  value?: IFilterVisitorJourneyValue[];
}

export enum EJourneyMatchType {
  CONTAINS = 'CONTAINS',
  EXACT = 'EXACT',
}
